import { Component, EventEmitter, Inject, Output } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { EventManager } from '@angular/platform-browser';

@Component({
  selector: 'ew-delete-payments',
  templateUrl: './action-confirmation.component.html',
  styleUrl: './action-confirmation.component.scss',
})
export class ActionConfirmationComponent {
  confirmation = new FormControl(false, [Validators.required]);
  unlockButton: boolean = true;
  @Output() onProceed = new EventEmitter<boolean>();

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: {
      title: string;
      message: string;
      proceedButton: string;
      cancelButton: string;
      eventManager: EventEmitter<boolean>;
    },
    private dialogRef: MatDialogRef<ActionConfirmationComponent>,
  ) {
    if (EventManager) this.onProceed = data.eventManager;
  }

  get validations() {
    return this.confirmation.value
      ? [this.confirmation.valid && this.unlockButton]
      : [false];
  }

  send() {
    this.onProceed.emit(true);
    this.dialogRef.close();
  }
}
